import React from 'react'

const ButtonInput = ({ hideBtn, method, label, type }) => {
    return (
        <div className={`${hideBtn ? "hide" : hideBtn}`}>
            <div className="slide-toggle text-center">
                <button type="button" className="btn btn-primary-grad editCancelBtn" onClick={method} value={type}>
                    {label}
                </button>
            </div>
        </div>)
}

export default ButtonInput